function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 14,
  y: 14,
  width: 40,
  height: 40,
  rx: 14,
  fill: "#FFC100"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47 42.2437C47 42.2437 44 46.2437 39 46.2437C34 46.2437 31 42.2437 31 42.2437",
  stroke: "#131416",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32.5,
  cy: 33.5,
  r: 1.25,
  stroke: "#131416",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45.5,
  cy: 33.5,
  r: 1.25,
  stroke: "#131416",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.2917 20H29.5C24.2533 20 20 24.2533 20 29.5V29.5M47.7083 20H48.5C53.7467 20 58 24.2533 58 29.5V29.5M58 48.5V48.5C58 53.7467 53.7467 58 48.5 58V58M29.5 58V58C24.2533 58 20 53.7467 20 48.5V48.5",
  stroke: "#131416",
  strokeWidth: 2.5,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.584 4.50131L17.4212 9.73371",
  stroke: "#FF8CBD",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.55054 8.56396L12.2489 12.0448",
  stroke: "#FF8CBD",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.47729 17.3862L9.71363 17.2683",
  stroke: "#FF8CBD",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

function SvgCropBicolors(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCropBicolors);
export default __webpack_public_path__ + "static/media/crop-bicolors.e6a24430.svg";
export { ForwardRef as ReactComponent };